<template>
  <mdb-container fluid v-bind:style="{ fontFamily: 'OpenSans-Regular', fontSize: '12px' }">
    <!--Section: Intro-->
    <mdb-row>
      <mdb-col>
        <h2 class="mt-lg-4 mb-1 pb-1" style="font-family: OpenSans-bold;">
          <strong>Áreas comunes</strong>
        </h2>
      </mdb-col>
      <mdb-col>
        <div class="mt-lg-4 mb-1 pb-1">
          <mdb-form-inline>
            <input v-on:keydown.enter.prevent="''" class="mr-sm-2 filter-input" type="text" v-model="search"
              style="width: 100% !important; border: 0px !important;" placeholder="Buscar área común" />
          </mdb-form-inline>
        </div>
      </mdb-col>
    </mdb-row>
    <!--Section: Main panel-->
    <section class="my-5">
      <!--Card-->
      <mdb-card cascade>
        <!--Section: Table-->
        <!--Top Table UI-->
        <div class="card card-cascade narrower z-depth-0">
          <!--Card image-->
          <div class="view view-cascade narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
            style="margin-top: -2.25rem; background-color: #67a3cf; position: static;">
            <div class="text-left">
              <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                <span slot="tip">Alta área común</span>
                <a slot="reference" @click="showModal = true; areaName = '';">
                  <img alt="nueva área común" class="mt-0"
                    :src="imgServer + 'apps/myfrac/admin/assets/Crear_BTN@3x.png'"
                    style="margin-left: 1rem; width: 31.2px; height: 31.2px; object-fit: contain;" />
                </a>
              </mdb-tooltip>
            </div>

            <span class="white-text"
              style="font-family: OpenSans-Bold; font-size: 16px; display: table; margin: 0 auto;">Áreas comunes
              registradas</span>

            <div class="text-right" style=" margin-top: -10px; display: flex; float: right;"></div>
          </div>
          <mdb-container>
            <div class="offset">
              <mdb-tbl class="table-st">
                <mdb-tbl-head class="text-center" responsive>
                  <tr>
                    <th scope="col">Área común</th>
                    <th scope="col">Dirección</th>
                    <th scope="col">Zona</th>
                    <th scope="col">Fraccionamiento</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                  <tr v-for="(item, index) in displayedPost" v-bind:key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.testStreet.name + ' #' + item.number }}</td>
                    <td>{{ item.testStreet.testZone.name }}</td>
                    <td>{{ item.testStreet.testZone.testFrac.name }}</td>
                    <td>
                      <div>
                        <mdb-tooltip material trigger="hover" :options="{ placement: 'top' }">
                          <span slot="tip">Editar</span>
                          <mdb-btn slot="reference" outline="white" rounded size="sm" class="px-2 button_background"
                            @click="getSingleArea(item.uuid, item.number)">
                            <mdb-icon icon="edit" class="mt-0" />
                          </mdb-btn>
                        </mdb-tooltip>
                        <mdb-tooltip v-if="isMe.idUsersTypes != 2" material trigger="hover"
                          :options="{ placement: 'top' }">
                          <span slot="tip">Eliminar</span>

                          <mdb-btn slot="reference" outline="white" rounded size="sm"
                            class="px-2 ml-2 button_background" style="width: 2rem;"
                            @click="deleteArea(item.uuid, item.name)">
                            <mdb-icon icon="trash" />
                          </mdb-btn>
                        </mdb-tooltip>
                      </div>
                    </td>
                  </tr>
                </mdb-tbl-body>
              </mdb-tbl>

              <!-- Componente de Paginación -->
              <Pagination :currentPage="page" :totalPages="numberOfPages" @page-change="goToPage" />

            </div>
          </mdb-container>
        </div>

        <!--Section: Table-->
      </mdb-card>
      <!--/.Card-->
    </section>
    <!--Section: Main panel-->

    <mdb-modal size="lg" :show="showModal" @close="resetModal">
      <mdb-modal-header class="text-center modal-header-style">
        <mdb-modal-title tag="span" class style="color: #ffffff;">{{ TitleModal }} área común</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3">
        <mdb-col>
          <form id="gateForm" class="needs-validation" novalidate @submit.prevent="submitForm">
            <mdb-row>
              <mdb-col>
                <div class="form-group">
                  <label style="font-family: OpenSans-Semibold;">Zona</label>
                  <model-select :options="zonesList" v-model="zoneModel" style="height: 37px;"
                    placeholder="Selecciona una zona" :isError="zoneValid"></model-select>
                </div>
              </mdb-col>
              <mdb-col>
                <div class="form-group">
                  <label style="font-family: OpenSans-Semibold;">Calle</label>
                  <model-select :options="streetList" v-model="streetModel" style="height: 37px;"
                    placeholder="Selecciona una calle" :isError="streetValid"></model-select>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col>
                <div class="form-group">
                  <label for="numberStreet" style="font-family: OpenSans-Semibold; font-size: 12px">Número</label>
                  <input type="text" class="form-control text-input" id="numberStreet" required maxlength="64"
                    v-model.trim="number" @blur="validateNumber"
                    :class="{ 'is-invalid': numberError, 'is-valid': !numberError && numberTouched }"
                    style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="invalid-feedback">Por favor, ingresa un número válido</div>
                </div>
              </mdb-col>
              <mdb-col>
                <div class="form-group">
                  <label for="nameGate" style="font-family: OpenSans-Semibold; font-size: 12px">Nombre</label>
                  <input type="text" class="form-control text-input" id="nameGate" required maxlength="64"
                    v-model.trim="areaName" @blur="validateName"
                    :class="{ 'is-invalid': nameError, 'is-valid': !nameError && nameTouched }"
                    style="height: 37px; margin-top: 10px; font-size: 12px; width: 100%;" />
                  <div class="invalid-feedback">Por favor, ingresa un nombre válido. Solo letras y números son
                    permitidos.</div>
                </div>
              </mdb-col>
            </mdb-row>
            <mdb-row>
              <div class="text-right mb-1" style="display: flex; position: relative; float: right; margin-left: auto;">
                <mdb-btn color="color-prev" type="button" class="btn-prev Rectngulo-14"
                  @click="resetModal">Cancelar</mdb-btn>
                <mdb-btn v-if="TitleModal == 'Agregar'" type="submit"
                  class="btn btn-next btn-color-next Rectngulo-14">Registrar</mdb-btn>
                <mdb-btn v-else type="submit" class="btn btn-next btn-color-next Rectngulo-14">Actualizar</mdb-btn>
              </div>
            </mdb-row>
          </form>
        </mdb-col>
      </mdb-modal-body>
    </mdb-modal>


  </mdb-container>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
import Axios from "axios";
import Servers from "../../../server.js";
import { ModelSelect } from "vue-search-select";
import { mapGetters, mapActions } from "vuex";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbSelect,
  mdbBtn,
  mdbDatePicker,
  mdbTooltip,
  mdbSimpleChart,
  mdbIcon,
  mdbFormInline,
  mdbBadge,
  mdbView,
  mdbLineChart,
  mdbListGroup,
  mdbListGroupItem,
  mdbInput,
  mdbDatatable,
  mdbAvatar,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbTbl,
  mdbTblHead,
  mdbTblBody
} from "mdbvue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "commonareas",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbSelect,
    mdbBtn,
    mdbDatePicker,
    mdbTooltip,
    mdbSimpleChart,
    mdbIcon,
    mdbFormInline,
    mdbBadge,
    mdbView,
    mdbLineChart,
    mdbListGroup,
    mdbListGroupItem,
    mdbInput,
    mdbDatatable,
    mdbAvatar,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    ModelSelect,
    Pagination,
  },
  data() {
    return {
      urlServer: Servers.serverApi,
      imgServer: Servers.serverImg,
      areaList: [],
      page: 1,
      perPage: 15,
      pages: [],
      numberOfPages: 0,
      requestShow: false,
      showModal: false,
      search: null,
      areaName: "",
      number: "",
      whoami: [],
      TitleModal: "Agregar",
      gate: [],
      zonesList: [],
      zoneModel: {
        value: "",
        uuid: "",
        text: ""
      },
      zoneValid: false,
      streetList: [],
      streetModel: {
        value: "",
        uuid: "",
        text: ""
      },
      streetValid: false,
      numberError: false,
      nameError: false,
      numberTouched: false,
      nameTouched: false
    };
  },
  methods: {
    // submitForm(event) {
    //   event.preventDefault();
    //   event.target.classList.add("was-validated");
    //   if(this.zoneModel.value){
    //       this.zoneValid=false;
    //   }
    //   else{
    //       this.zoneValid=true;
    //   }
    //   if(this.streetModel.value){
    //       this.streetValid = false;
    //         if (this.areaName != "") {
    //     if (this.TitleModal == "Agregar") {
    //         if(this.number !="")
    //             this.postArea(this.streetModel.value);
    //     } else {
    //          if(this.number !="")
    //             this.putArea(this.streetModel.value);
    //     }
    //   }
    //   }
    //   else {
    //       this.streetValid = true;
    //   }

    // },

    resetModal() {
      this.showModal = false;
      this.TitleModal = 'Agregar';
      this.zoneModel = {};
      this.streetModel = {};
      this.number = '';
      this.areaName = '';
      this.numberError = false;
      this.nameError = false;
      this.numberTouched = false;
      this.nameTouched = false;
    },
    // Validación del campo "Número"
    validateNumber() {
      this.numberTouched = true;
      const numberRegex = /^[0-9]+$/;  // Solo números naturales
      this.numberError = !numberRegex.test(this.number);
      return !this.numberError;
    },
    // Validación del campo "Nombre"
    validateName() {
      this.nameTouched = true;
      const nameRegex = /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/;  // Acepta alfanuméricos, ñ y acentos
      this.nameError = !nameRegex.test(this.areaName.trim());
      return !this.nameError;
    },

    submitForm(event) {
      event.preventDefault();

      // Realizamos las validaciones
      // this.validateNumber();
      // this.validateName();
      const isZoneValid = this.validateZone();
      const isStreetValid = this.validateStreet();
      const isNumberValid = this.validateNumber();
      const isAreaNameValid = this.validateName();

      // Si alguna validación falla, detenemos el flujo
      if (!isZoneValid || !isStreetValid || !isNumberValid || !isAreaNameValid) {
        this.showMessageError("Error", "Por favor, corrige los campos indicados.");
        return;
      }

      event.target.classList.add("was-validated");
      // Si todos los campos son válidos, procedemos con la lógica de registro/actualización
      if (this.TitleModal === "Agregar") {
        this.postArea(this.streetModel.value);
      } else {
        this.putArea(this.streetModel.value);
      }
    },

    // Métodos de validación específicos para cada campo
    validateZone() {
      if (!this.zoneModel || !this.zoneModel.value) {
        this.zoneValid = true; // Muestra error en el selector de Zona
        return false;
      } else {
        this.zoneValid = false;
        return true;
      }
    },

    validateStreet() {
      if (!this.streetModel || !this.streetModel.value) {
        this.streetValid = true; // Muestra error en el selector de Calle
        return false;
      } else {
        this.streetValid = false;
        return true;
      }
    },

    // validateNumber() {
    //   if (!this.number || this.number.trim() == "") {
    //     this.showMessageError("Error", "Por favor, proporciona un número válido.");
    //     return false;
    //   }
    //   return true;
    // },

    // validateAreaName() {
    //   if (!this.areaName || this.areaName.trim() == "") {
    //     this.showMessageError("Error", "Por favor, proporciona un nombre para el área.");
    //     return false;
    //   }
    //   return true;
    // },

    getZones() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/zones", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function (response) {
          aux.zonesList = [];
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].idZone,
              uuid: response.data[i].uuid,
              text: response.data[i].name
            };
            aux.zonesList.push(temp);
          }
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    getStreets(zoneUuid) {
      let aux = this;
      Axios.get(Servers.serverApi + "api/streets/zones/" + zoneUuid, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function (response) {
          aux.streetList = [];
          for (var i = 0; i < response.data.length; i++) {
            var temp = {
              value: response.data[i].idStreet,
              uuid: response.data[i].uuid,
              text: response.data[i].name
            };
            aux.streetList.push(temp);
          }
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    getAreas() {
      let aux = this;
      Axios.get(Servers.serverApi + "api/commonareas/complete", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function (response) {
          aux.areaList = response.data;
          aux.numberOfPages = Math.ceil(aux.areaList.length / aux.perPage);
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    getSingleArea(uuid, numero) {
      this.TitleModal = "Editar";
      this.showModal = true;
      let found = this.areaList.find(element => element.uuid == uuid);
      let foundZone = this.zonesList.find(element => element.uuid === found.testStreet.testZone.uuid);
      this.zoneModel = foundZone;
      this.streetModel = {
        value: found.testStreet.idStreet,
        uuid: found.testStreet.uuid,
        text: found.testStreet.name
      };

      this.number = numero;
      this.areaName = found.name;
      this.gate = found;
    },
    putArea(idStreet) {
      let aux = this;
      var data = {
        name: aux.areaName,
        idStreet: idStreet,
        number: aux.number
      };
      Axios.put(
        Servers.serverApi + "api/commonareas/" + aux.gate.uuid,
        data,
        {
          responseType: "application/json",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }
      )
        .then(function (response) {
          aux.showMessageSucces();
        })
        .catch(error => {
          this.showMessageError("Error", error.response.data.error_description);
          console.log(error.response.data);
        });
    },
    postArea(idStreet) {
      let aux = this;
      var data = [
        {
          name: aux.areaName,
          number: aux.number,
          idStreet: idStreet
        }
      ];
      Axios.post(Servers.serverApi + "api/commonareas", data, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(function (response) {
          aux.showMessageSucces();
        })
        .catch(error => {
          this.showMessageError("Error", error.response.data.error_description);
          console.log(error.response.data);
        });
    },
    deleteArea(uuid, name) {
      let aux = this;
      Swal.fire({
        title: "¿Seguro que deseas eliminar " + name + "?",
        text: "No podrás revetir esta acción",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          Axios.delete(Servers.serverApi + "api/commonareas/" + uuid, {
            responseType: "application/json",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token")
            }
          })
            .then(function (response) {
              aux.showMessageSucces();
            })
            .catch(function (error) {
              console.log(error.response.data);
            });
        }
      });
    },
    setPages() {
      this.pages = [];
      for (let index = 1; index <= this.numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(wList) {
      let aux = this;
      aux.numberOfPages = Math.ceil(wList.length / aux.perPage);
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      this.setPages();
      return wList.slice(from, to);
    },
    showMessageError: function (text, error) {
      let aux = this;
      let errorText;
      Swal.fire({
        title: "<span style='font-size: 20px'>" + text + "</span>",
        html: "<span style='font-size: 12px'>" + error + "</span>",
        imageUrl: "../static/Cancel_icon.png",
        imageWidth: "22%",
        imageHeight: "auto",
        width: "30%",
        //confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => { }
      });
    },
    showMessageSucces: function () {
      Swal.fire({
        title: "<span style='font-size: 20px;'>¡Correcto!</span>",
        html: "<span style='font-size: 12px;'></span>",
        type: "success",
        width: "30%",
        confirmButtonText: "Aceptar",
        customClass: {
          confirmButton: "btn-modal-accept"
        },
        onClose: () => {
          window.location.reload();
        }
      });
    },
    goToPage(pageNumber) {
      this.page = pageNumber;
      this.getAreas(); // Llamada para actualizar los datos según la página seleccionada
    },
  },
  mounted() { },
  created() {
    //this.checkMe();
    this.whoami = JSON.parse(localStorage.getItem("me"));
    this.getAreas();
    this.getZones();
  },
  watch: {
    areaList() {
      this.setPages();
    },
    zoneModel(newZone) {
      this.zoneModel = newZone;
      if (newZone.value) {
        this.zoneValid = false;
        this.getStreets(newZone.uuid);
      } else {
        this.zoneValid = true;
      }
    },
    streetModel(newStreet) {
      this.streetModel = newStreet;
      if (newStreet.value) {
        this.streetValid = false;
      } else {
        this.streetValid = true;
      }
    }
  },
  computed: {
    ...mapGetters({
      isMe: "getWhoAmi",
    }),
    displayedPost() {
      if (this.search) {
        this.page = 1
        return this.paginate(
          this.areaList.filter(item => {
            return (
              item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            );
          })
        );
      } else return this.paginate(this.areaList);
    },

  }
};
</script>

<style scoped>
::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
  opacity: 1;
  /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #fff;
}

.table-st {
  border-collapse: collapse !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
}

.tooltip-p {
  position: relative;
  display: inline-block;
}

/* Tooltip text */
.tooltip-p .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip-p .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip-p:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.HeadBG {
  background-color: #f5f6fa;
  font-family: "OpenSans-Semibold" !important;
  color: #747474;
  font-size: 12px;
  text-align: center !important;
}

.table>tbody {
  text-align: center;
}

.Trazado-295 {
  width: auto;
  height: 35px;
  border: solid 1px #e8e9ec !important;
  background-color: #ffffff !important;
}

.filter-input {
  position: initial;
  margin-left: 0.5em;
  margin-right: 1rem;
  margin-top: 2rem;
  border-radius: 25px;
  height: 35px;
  padding-left: 35px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.filter-input:focus {
  font-family: "OpenSans-Regular";
  font-size: 12px;
  color: #fff;
  background: url("../../../static/zoom_in.png") no-repeat scroll 12px 7px #67a3cf;
  background-size: 20px 20px;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.table>thead>tr>th {
  text-align: center !important;
}
</style>

<style></style>